export const communitySections = [
  { id: "treasure", name: "Content", path: "/classes" },
  { id: "announcements", name: "Announcements", path: "/channels/announcements" },
];

export function sectionForPath(pathname, slug) {
  const base = `/courses/${slug}`;
  if (pathname !== base && !pathname.startsWith(`${base}/`)) return null;
  const path = pathname.slice(base.length).replace(/\/$/, "");
  return communitySections.find(section => section.path
    ? path === section.path || path.startsWith(`${section.path}/`)
    : path === "") || null;
}
